import React, { useContext } from "react";
import {
  Route,
  Redirect,
  RouteComponentProps,
  RouteProps,
} from "react-router-dom";
import { authContext } from "../../providers";

type Props = {
  component:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>;
};

const GuestRoute: React.FC<RouteProps & Props> = ({
  component: Component,
  ...rest
}) => {
  const { auth } = useContext(authContext);
  return (
    <Route
      {...rest}
      render={(routeProps) =>
        auth.data ? <Redirect to="/" /> : <Component {...routeProps} />
      }
    />
  );
};

export default GuestRoute;
